import { FC } from 'react';

import { BlogSectionType } from '../../../models/Content';
import { ContentfulImage } from '../../common/ContentfulImage';
import { StyledSectionImageWrapper } from './SectionImage.styles';
import { transformSectionImage } from './transformers';

type Props = {
    contentItem: BlogSectionType;
};

export const SectionImage: FC<Props> = ({ contentItem }) => {
    const image = transformSectionImage(contentItem);
    const { url, alt, width, height } = image;

    if (!url) {
        return null;
    }

    return (
        <StyledSectionImageWrapper>
            <ContentfulImage src={url} alt={alt} width={width} height={height} />
        </StyledSectionImageWrapper>
    );
};
